<main class="login-card">
  <header class="login-heading">
    <img class="login-logo" src="assets/active-f-logo.png" alt="ActiveF">
    <h1>Welcome to ActiveF</h1>
    <p>{{ ssoMode ? 'Sign in with your corporate account' : 'Sign in to your account' }}</p>
  </header>
  @if (error) { <p role="alert">{{ error }}</p> }

  @if (!tenantSlug) { <p>Open your company's ActiveF sign-in link to continue.</p> }
  @if (busy && !tenant) { <p role="status">Loading sign-in...</p> }
  @if (tenant) {
  <p class="selected-company">Company: {{ tenantSlug }}</p>
  @if (signedIn) {
    <p role="status">Taking you to ActiveF...</p>
  } @else {
  @if (tenant?.passwordEnabled) {
  <div [hidden]="ssoMode">
    <amplify-authenticator [hideSignUp]="true" [socialProviders]="[]" [loginMechanisms]="['username']"
      [formFields]="formFields" [services]="services">
      <ng-template amplifySlot="sign-in-footer">
        <div class="login-actions">
          @if (tenant?.ssoProvider) {
          <div class="login-divider"><span>OR</span></div>
          <button class="sso-button" type="button" (click)="showSso(true)">
            Sign in with SSO
          </button>
          }
          <button class="text-button" type="button" (click)="authenticator.toForgotPassword()">Forgot your
            password?</button>
        </div>
      </ng-template>
      <ng-template amplifySlot="authenticated" let-user="user">
        <p>You are signed in as {{ user.username }}.</p>
        <div class="login-actions">
          <button mat-flat-button type="button" [disabled]="busy" (click)="continueToApp()">Continue to Active
            Finance</button>
          <button mat-button type="button" [disabled]="busy" (click)="signOut()">Sign out</button>
        </div>
      </ng-template>
    </amplify-authenticator>
  </div>
  }

  @if (ssoMode) {
  <section aria-labelledby="sso-title">
    <h2 id="sso-title" class="visually-hidden">Sign in with SSO</h2>
    <form (submit)="$event.preventDefault(); signInWithSso()">
      <div class="sso-field amplify-flex amplify-field amplify-textfield">
        <label for="sso-username" class="visually-hidden">Username</label>
        <div class="amplify-field-group__field-wrapper">
          <input id="sso-username" class="amplify-input amplify-field-group__control" name="sso-username"
            type="email" autocomplete="username" [formControl]="username" placeholder="Username" required
            [attr.aria-invalid]="username.touched && username.invalid"
            [attr.aria-describedby]="username.touched && username.invalid ? 'sso-username-error' : null">
        </div>
        @if (username.touched && username.invalid) {
        <p id="sso-username-error" class="amplify-field__error-message">Enter your corporate email address.</p>
        }
      </div>
      <div class="login-actions">
        <button class="primary-button" type="submit" [disabled]="busy">{{ busy ? 'Connecting...' : 'Sign in' }} <span
            aria-hidden="true">→</span></button>
        @if (tenant?.passwordEnabled) {
        <button class="text-button" type="button" [disabled]="busy" (click)="showSso(false)">Sign in with a
          password</button>
        }
      </div>
    </form>
  </section>
  }
  }
  }
</main>
